import axios from 'axios'
import config from '../config'

interface IProduct {
  product_name ?: string;
  product_id: string;
}

interface IOffer {
  offer_name ?: string;
  offer_id: string;
}

interface IMemebership {
  offers?: IOffer[];
  products?: IProduct[];
}

export interface IBuilderSettings {
  id: string;
  locationId: string;
  userId: string | null;
  downloadOption: boolean;
  appSettings: object | null;
  pwaEnabled: boolean | false;
  createdAt: Date;
  updatedAt: Date;
}

export class LocationMembership {

  private locationId: string;

  static get headers() {
    return {
      channel: 'APP',
      source: 'WEB_USER',
      version: '2021-07-28',
      ContentType: 'application/json',
    }
  }

  public offers : ReadonlyArray<IOffer> = [];
  public products: ReadonlyArray<IProduct> = [];

  private constructor(locationId: string){
    this.locationId = locationId;
  }

  public static async forLocation(locationId: string){

    const membership = new LocationMembership(locationId);
    let dto: IMemebership = null;
    try {
      const response = await axios.get<IMemebership>(`${config.membershipUrl}/smart-list/offers-products/${locationId}` , {
        headers: this.headers
      });
      dto = response.data;
    } catch (err) {
      console.info(`Error fetching membership information for location - ${locationId}`);
      console.log(err);
    }
    if (dto && dto.offers) membership.offers = dto.offers;
    if (dto && dto.products) membership.products = dto.products;
    return membership;
  }

  public static async clearAppliedThemes(locationId: string) {
    await axios.put(
      `${config.membershipUrl}/smart-list/clear-applied-theme/${locationId}`,
      {
        headers: {
          ContentType: 'application/json',
        },
      }
    )
  }

  public static async createAxiosInstance(switchToAuthHeader: boolean) {
    const apiKey = await window.getToken()
    const authHeader = switchToAuthHeader ? {
      authorization: `Bearer ${apiKey}`
    } : {
      'token-id': apiKey
    }
    return axios.create({
      headers: {
        Channel: 'APP',
        Source: 'WEB_USER',
        Version: '2021-04-15',
        ...authHeader
      }
    })
  }

  public static async executeAPICall(url: string, params = {}, switchToAuthHeader = false) {
    const axiosInstance = await this.createAxiosInstance(switchToAuthHeader)
    try {
      const response = await axiosInstance.get(url, params).then(res => res.data)
      return response
    } catch {
      return null
    }
  }

  public static async getPortalSettingsByLocationId(locationId: string) {
    return this.executeAPICall(`${config.restApiUrl}/clientclub/portal-settings/${locationId}`)
  }

  public static async getSiteInfoByLocationId(locationId: string) {
    return this.executeAPICall(`${config.membershipUrl}/locations/${locationId}/settings/site-info/`, {}, true)
  }

  public static async getDomainInfoByLocationId(locationId: string, params: { type: string }) {
    return this.executeAPICall(`${config.membershipUrl}/locations/${locationId}/settings/domain/`, { params }, true)
  }

  public static async getBuilderSettingsByLocationId(locationId: string): Promise<IBuilderSettings> {
    return this.executeAPICall(`${config.membershipUrl}/locations/${locationId}/settings/builder-settings`)
  }
}
